import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    templateUrl: './changeCriteriaDialog.component.html',
    standalone: false
})
export class ChangeCriteriaDialogComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<ChangeCriteriaDialogComponent>) { }

    ngOnInit(): void {
        // nothing to initialize yet
    }

    ok(): void {
        this.dialogRef.close(true);
    }

    cancel(): void {
        this.dialogRef.close(false);
    }

}
